import { motion } from 'framer-motion';
import SiteMeta from '../components/SiteMeta';
import { useNavigation } from '../context/NavigationContext';
import SnippetsList from '../components/SnippetsList';
import Footer from '../components/Footer';
import Lottie from 'lottie-react';
import { useRef, useEffect, useState } from 'react';
import './Snippets.css';

function Snippets() {
  const { destinationPage, activePage, clearDestination } = useNavigation();
  const isDestination = destinationPage === 'snippets';
  const isActive = activePage === 'snippets';
  const lottieRef = useRef();
  const [animationData, setAnimationData] = useState(null);

  useEffect(() => {
    // Try loading the animation data
    fetch('/src/assets/lottie_animations/Snippets.json')
      .then(response => response.json())
      .then(data => {
        setAnimationData(data);
      })
      .catch(error => {
        console.error('Error loading Snippets animation:', error);
        // Fallback to direct import
        import('../assets/lottie_animations/Snippets.json')
          .then(module => {
            setAnimationData(module.default);
          })
          .catch(importError => {
            console.error('Error importing Snippets animation:', importError);
          });
      });
  }, []);

  useEffect(() => {
    if (animationData && lottieRef.current) {
      setTimeout(() => {
        lottieRef.current.play();
      }, 300);
    }
  }, [animationData]);

  return (
    <>
      <SiteMeta
        title="Snippets - Robin Gardeur (le Shka)"
        description="Design snippets, experiments, and creative explorations by Robin Gardeur (le Shka) - Director x Digital Artist."
      />
      <motion.div
        className={`page ${isDestination ? 'page-transitioning' : ''} ${isActive ? 'page-active' : ''}`}
        initial={{ y: '100vh' }}
        animate={{ y: 0 }}
        exit={{ y: '-20vh' }}
        transition={{
          duration: 1,
          ease: [0.4, 0, 0.2, 1],
          type: "tween"
        }}
        onAnimationComplete={() => {
          if (isDestination) {
            clearDestination();
          }
        }}
      >
      <div className="title snippets-title">
        {animationData ? (
          <Lottie 
            lottieRef={lottieRef}
            animationData={animationData}
            loop={false}
            autoplay={false}
            style={{ width: 'auto', height: 'auto' }}
          />
        ) : (
          <h1>Snippets</h1>
        )}
      </div>
      <SnippetsList />
      <Footer />
      </motion.div>
    </>
  );
}

export default Snippets;